"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _FlexItem = _interopRequireDefault(require("../Layouts/FlexItem"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This to provide form item styling to a component.
 *
 * @param {ReactComponent} WrappedComponent - React component to be wrapped.
 * @return {ReactComponent} - react a wrapped React Component.
 * @constructor
 */
function FormItemProvider(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              label = _this$props.label,
              helpText = _this$props.helpText,
              error = _this$props.error,
              id = _this$props.id,
              secondaryLabel = _this$props.secondaryLabel,
              formItemProviderProps = _this$props.formItemProviderProps,
              props = _objectWithoutProperties(_this$props, ["label", "helpText", "error", "id", "secondaryLabel", "formItemProviderProps"]);

          var styleProps = {
            'data-has-help-text': !!helpText,
            'data-has-label': !!label || !!secondaryLabel,
            'data-has-error': error
          };
          return _react.default.createElement(_StackingLayout.default, _extends({
            className: (0, _classnames.default)('ntnx-form-item-provider'),
            itemSpacing: "10px"
          }, formItemProviderProps, styleProps), label || secondaryLabel ? this.renderLabel() : null, _react.default.createElement(WrappedComponent, _extends({
            id: id,
            error: error
          }, props)), helpText ? this.renderHelpText() : null);
        }
        /**
         * Render label for form item
         * @returns {ReactElement} - label
         */

      }, {
        key: "renderLabel",
        value: function renderLabel() {
          var _this$props2 = this.props,
              id = _this$props2.id,
              label = _this$props2.label,
              secondaryLabel = _this$props2.secondaryLabel;
          var labels = [_react.default.createElement("label", {
            key: "primaryLabel",
            htmlFor: id
          }, label)];

          if (secondaryLabel) {
            labels.push(_react.default.createElement("label", {
              key: "secondaryLabel",
              htmlFor: id
            }, secondaryLabel));
          }

          return _react.default.createElement(_FlexLayout.default, {
            className: "label-wrapper",
            justifyContent: "space-between"
          }, labels);
        }
        /**
         * Render help text for form item
         * @returns {ReactElement} - help text
         */

      }, {
        key: "renderHelpText",
        value: function renderHelpText() {
          var helpText = this.props.helpText;
          return _react.default.createElement(_FlexItem.default, {
            className: "help-text"
          }, helpText);
        }
      }]);

      return _class;
    }(_react.default.Component)
  );
}

FormItemProvider.defaultProps = {
  formItemProviderProps: {}
};
FormItemProvider.propTypes = {
  /**
   * Unique id for the label and the WrappedComponent.
   * This is required when using the label with input as it will
   * ensure that when label is clicked it auto focuses on the input.
   */
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * This is the primary description label at the top left of
   * the input dom.  If this is a string then the label will be properly
   * styled.  If it is a React element then it is up the application to
   * style appropriately.
   */
  label: _propTypes.default.node,

  /**
   * This is a secondary label which is often used to give more description
   * about the input. If this is a string then the label will be properly
   * styled.  If it is a React element then it is up the application to
   * style appropriately.
   */
  secondaryLabel: _propTypes.default.node,

  /**
   * This is the help text at the bottom left of the input dom.  Can be
   * used as a short description to the input field or if props.error is
   * set to true then this will be styled in red to serve as an error
   * message.  In normal usage this expect to be of type string and will be
   * styled appropriately, but application can override this styling by
   * passing in their own React element.
   */
  helpText: _propTypes.default.node,

  /**
   * Error styling for the help text.
   */
  error: _propTypes.default.bool,

  /**
   * This is additional props to be passed to the parent wrapper dom.  If you
   * need to style the WrappedComponent just pass in props.style instead.
   */
  formItemProviderProps: _propTypes.default.object
};
/**
 * @component
 */

var _default = FormItemProvider;
exports.default = _default;